module.exports = __webpack_public_path__ + "assets/img/free_34.5e762be7.png";